import { inventoryApi } from '../api/inventoryApi'
import type { InventoryCategoryCreateData } from '../schema/inventorySchema'

export const createCategory = async (category: InventoryCategoryCreateData) => {
  try {
    const { data } = await inventoryApi.createCategory(category)
    return data
  } catch (error) {
    console.error(`Error creating category: `, error)
    throw error
  }
}
